"use strict";

angular.module("vendor")
.service("CatalogEntryVariantsService", function($resource, $http, gettextCatalog, FlashBag, appConfig) {
    var catalogEntryVariantResource = $resource(appConfig.API_SERVER + "/variants/catalog-entry-variants/:id/", {id: "@id"}, {
        patch: {
            method: "PATCH",
            ignoreLoadingBar: true
        },
        delete: {
            method: "DELETE",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.patchField = function(id, fieldParam) {
        var params = angular.extend({id: id}, fieldParam);
        var catalogEntry = new catalogEntryVariantResource(params);
        return catalogEntry.$patch();
    };

    this.delete = function(id) {
        return catalogEntryVariantResource.delete({id: id}).$promise;
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/catalog/catalog-entry-variants.service.js
// module id = 878
// module chunks = 0